"use strict";import{IconCheckmark300 as e}from"../src/elements/IconCheckmark300.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-checkmark300",e);
//# sourceMappingURL=sp-icon-checkmark300.js.map
